import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import extendFieldApi from 'api/extendFieldApi'
import invoiceApi from 'api/invoiceApi'
import templateInvoiceApi from 'api/templateInvoiceApi'
import ToastHelper from 'general/helpers/ToastHelper'

export function useFetchInvoice({
  redirectUrl,
  setInvoiceData,
  setTableDetailExtendFields,
  setBuyerInfoExtendFields,
  setLatestInvoice,
  setInvoiceType,
  setLatestInvoiceTemplate,
  setTemplateInvoiceSerials,
  setInvoiceTemplateDetail,
  isFromPOS,
  isDeliveryBill,
}) {
  const navigate = useNavigate()

  const fetchInvoiceData = useCallback(
    async (invoiceId) => {
      try {
        const res = await invoiceApi.findById(invoiceId)
        if (res?.result === 'success') {
          setInvoiceData(res.data)
          return res.data
        } else {
          navigate(redirectUrl)
          ToastHelper.showError('Không tìm thấy dữ liệu')
        }
      } catch (err) {
        navigate(redirectUrl)
        ToastHelper.showError('Có lỗi khi tìm dữ liệu')
      }
    },
    [navigate, setInvoiceData, redirectUrl],
  )

  const fetchExtendFields = useCallback(async () => {
    let res = await extendFieldApi.getExtendFields()

    if (!res?.extendFields) {
      setTableDetailExtendFields([])
      setBuyerInfoExtendFields([])
      return
    }

    setTableDetailExtendFields(
      res.extendFields.filter(({ regionName }) =>
        ['tableDetail', 'tableDetail1'].includes(regionName),
      ),
    )
    setBuyerInfoExtendFields(
      res.extendFields.filter(({ regionName }) => regionName === 'buyerInfo'),
    )
  }, [setTableDetailExtendFields, setBuyerInfoExtendFields])

  const fetchLatestInvoice = useCallback(async () => {
    try {
      let classify
      switch (window.location.pathname) {
        case '/hoa-don-dau-ra/hoa-don/them-moi':
          classify = 'HD'
          break
        case '/hoa-don-dau-ra/hoa-don/may-tinh-tien/them-moi':
          classify = 'MTT'
          break
        case '/hoa-don-dau-ra/hoa-don/phieu-xuat-kho/them-moi':
          classify = 'PXK'
          break
        default:
          classify = null
      }

      const res = await invoiceApi.latest({ ...(classify && { classify }) })
      if (res?.result === 'success') {
        setLatestInvoice(res.rows)
        setInvoiceType(res.rows?.invoice_template?.type)
      }
    } catch (err) {
      console.error('Lỗi khi lấy hóa đơn mới nhất:', err)
    }
  }, [setLatestInvoice, setInvoiceType])

  const fetchLatestInvoiceTemplate = useCallback(
    async (invoiceTemplateId) => {
      try {
        const res = await invoiceApi.findLatestInvoiceRelease(invoiceTemplateId)
        if (res?.result === 'success') {
          setLatestInvoiceTemplate(res.rows)
          setInvoiceTemplateDetail(res?.invoiceTemplate)
          // setTemplateIdUsed(res.rows?.invoiceTemplateId);
        }
      } catch (err) {
        console.error('Lỗi khi lấy template hóa đơn mới nhất:', err)
      }
    },
    [setLatestInvoiceTemplate],
  )

  const fetchTemplateSerial = useCallback(async () => {
    let res
    try {
      let params = undefined
      if (isFromPOS) params = { invoiceClassify: 'MTT' }
      else if (isDeliveryBill) params = { invoiceClassify: 'PXK' }

      res = await templateInvoiceApi.getTemplateSerials(params)
    } catch (e) {
      return
    }
    if (res?.data?.length) {
      let serials = res?.data
      serials.map((item) => {
        item.label = item.serial
        item.value = item.invoiceTemplateId
      })
      setTemplateInvoiceSerials(serials)
    } else {
      // ToastHelper.showError('Không lấy được thông tin ký hiệu hoá đơn');
      ToastHelper.showError(
        'Bạn chưa thực hiện đăng ký mẫu hóa đơn hoặc không được phân quyền sử dụng mẫu hóa đơn nào. Hãy thực hiện đăng ký trước khi lập hóa đơn',
      )
    }
  }, [setTemplateInvoiceSerials, isDeliveryBill, isFromPOS])

  return {
    fetchInvoiceData,
    fetchExtendFields,
    fetchLatestInvoice,
    fetchLatestInvoiceTemplate,
    fetchTemplateSerial,
  }
}
